.editorContainer {
	margin: 0 50px 0 50px;
}

:global(.codeMarker) {
	background: #fff677;
	position: absolute;
	z-index: 20;
}
